export const VN = 'vn'
export const EN = 'en'
export const LANE = "NETCO_language"